module.exports = __webpack_public_path__ + "img/help_icon_pink.c4589fa7.svg";